// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';

const PrivateCreditMemoCellRenderer = props =>
    <div className='credit-memo-cell-renderer'>
        {props.data.isSubmittingDealer ?
            <SmartFormLink
                displayText={props.value}
                formName='CREDITMEMO'
                objectId={props.value}
            /> :
                props.value
        }
    </div>;

PrivateCreditMemoCellRenderer.displayName = 'PrivateCreditMemoCellRenderer';
PrivateCreditMemoCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
};

export default PrivateCreditMemoCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/private-credit-memo-cell-renderer.js